const HorizontalStepperSlider = ({
  min,
  max,
  step = 1,
  value,
  onChange,
  formatValue = (v) => v,
  color = "#FF8C65",
  disabled = false,
  label,
  ariaLabel = label,
  "data-testid": dataTestId = "horizontal-stepper-slider",
}) => {
  const clamp = (v) => Math.min(Math.max(v, min), max);

  const handleDecrement = () => {
    if (disabled) return;
    onChange(clamp(value - step));
  };

  const handleIncrement = () => {
    if (disabled) return;
    onChange(clamp(value + step));
  };

  const handleRangeChange = (e) => {
    if (disabled) return;
    onChange(clamp(Number(e.target.value)));
  };

  return (
    <div
      className={`flex flex-col gap-2 w-full ${disabled ? "opacity-40 pointer-events-none" : ""}`}
      data-testid={dataTestId}
    >
      {label && (
        <span className="text-dark-grey dark:text-white text-xs font-semibold tracking-[0.03px] uppercase text-center">
          {label}
        </span>
      )}
      <div className="relative h-16 rounded-full overflow-hidden" style={{ backgroundColor: color }}>
        <span
          className="absolute inset-0 flex items-center justify-center text-white text-3xl font-bold pointer-events-none"
          data-testid={`${dataTestId}-value`}
        >
          {formatValue(value)}
        </span>
        <div className="relative z-10 h-full flex items-center justify-between px-5 pointer-events-none">
          <button
            type="button"
            onClick={handleDecrement}
            disabled={disabled || value <= min}
            aria-label={ariaLabel ? `Decrease ${ariaLabel}` : "Decrease"}
            data-testid={`${dataTestId}-decrement`}
            className="pointer-events-auto text-white text-2xl font-semibold leading-none disabled:opacity-40"
          >
            −
          </button>
          <button
            type="button"
            onClick={handleIncrement}
            disabled={disabled || value >= max}
            aria-label={ariaLabel ? `Increase ${ariaLabel}` : "Increase"}
            data-testid={`${dataTestId}-increment`}
            className="pointer-events-auto text-white text-2xl font-semibold leading-none disabled:opacity-40"
          >
            +
          </button>
        </div>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleRangeChange}
          disabled={disabled}
          aria-label={ariaLabel || "value"}
          data-testid={`${dataTestId}-range`}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed"
        />
      </div>
    </div>
  );
};

export default HorizontalStepperSlider;
